import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface NiveauLivreurDTO {
  id?: number;
  nom: string;
  seuilMinCourses: number;
  couleur: string;
  emoji: string;
  primeFixeMensuelle: number;
  primePourcentageCa: number;
  ordre: number;
}

export interface StatsLivreurDTO {
  coursesLivrees: number;
  coursesTotales: number;
  gainsTotaux: number;
  noteMoyenne: number | null;
  nbAvis: number;
  palier: {
    label: string;
    niveau: number;
    restantes: number;
    progression: number;
    couleur: string | null;
    emoji: string | null;
    primeFixe: number;
    primePct: number;
  };
  mois: {
    coursesLivrees: number;
    gains: number;
    coursesProjetees: number;
    gainsProjectes: number;
    primeProjetee: number;
    jourAujourdhui: number;
    joursTotal: number;
  };
}

@Injectable({ providedIn: 'root' })
export class NiveauLivreurService {
  private api = environment.apiurl + 'niveaux-livreur';
  private apiLivreurs = environment.apiurl + 'livreurs';

  constructor(private http: HttpClient) {}

  lister(): Observable<NiveauLivreurDTO[]> {
    return this.http.get<NiveauLivreurDTO[]>(this.api);
  }

  creer(dto: NiveauLivreurDTO): Observable<NiveauLivreurDTO> {
    return this.http.post<NiveauLivreurDTO>(this.api, dto);
  }

  modifier(id: number, dto: NiveauLivreurDTO): Observable<NiveauLivreurDTO> {
    return this.http.put<NiveauLivreurDTO>(`${this.api}/${id}`, dto);
  }

  supprimer(id: number): Observable<void> {
    return this.http.delete<void>(`${this.api}/${id}`);
  }

  getStats(livreurId: number): Observable<StatsLivreurDTO> {
    return this.http.get<StatsLivreurDTO>(`${this.apiLivreurs}/${livreurId}/stats`);
  }
}
